module.exports = __webpack_public_path__ + "static/media/PersonNotFound.d83f2cbc.svg";